/* eslint-disable react/jsx-pascal-case */

import { FC } from 'react' ;
import Service_Tag_Section from './Service_Tag_Section' ;
import Service_Tag_PetInfo from './Service_Tag_PetInfo' ;
import Service_Tag_CheckStatus from './Service_Tag_CheckStatus' ;
import Service_Tag_ServiceDate from './Service_Tag_ServiceDate' ;
import Service_Tag_Payment from './Service_Tag_Payment';
import Service_Tag_ArriveLeave from './Service_Tag_ArriveLeave';
import Service_Tag_ServiceContent from './Service_Tag_ServiceContent' ;
import { string_Replace_WithAsterisks } from 'utils/string/edit_string';





type Tag = {
    data : any
}

// @ 列印標籤：第一聯 ( 跟著寵物 )第二聯 ( 跟著帶來的物品 )第三聯 ( 洗澡 / 美容 紀錄表 _ 放美容室 )
const Service_Tag_6 : FC< Tag > = ( { data } ) => {


    // 寵物資料
    const pet          = data?.pet ;
	
	// 寵物 _ 洗澡美容備註
    const pet_Note = <b className = "f_16"> { pet?.note ? pet?.note : "" }  </b>
	
	// 自備物品
    const customer_Object = <>
                              <div>
                                  勾選 :  { data?.customer_object ? <b className = "f_15" > { data?.customer_object } </b> : "未勾選"  } 
                              </div>
                              <div>
                                  其他 :  { data?.customer_object_other ? <b className = "f_15" > { data?.customer_object_other } </b> : "未填寫"  }  
                              </div>
                            </> ;

    // 服務類型
    const service_Type = data?.service_type ;

    // 主人資料
    const customer     = data?.customer ;
	
    // 簽收區塊
    const sign_Zone    = <div style = {{ height : "30px" }}></div> ;


    return <div style={{ color:"black" }}>
	
                <div style={{ pageBreakAfter: 'always' }}>
				
				<b className = "f_15"> [ 第一聯 : 寵物 ]  </b> 

				<hr className  = "border m_Bottom_30" />

				{ /* 服務日期、Ｑ碼、類型、id */ }
				<Service_Tag_ServiceDate data = { data } />

				{ /* 寵物資訊 */ }
				<Service_Tag_PetInfo pet = { pet } />

				{ /* 到店、離店 */ }
				<Service_Tag_ArriveLeave arrive = { data?.way_arrive } leave = { data?.way_leave } />

				{ /* 洗澡美容備註 */ } 
				<Service_Tag_Section icon = "fas fa-dog" title = "洗澡美容：常駐備註" content = { pet_Note } options = { pet?.check_note } />
					
				</div>
				
				<div style={{ pageBreakAfter: 'always' }}>
				
				<b className = "f_15"> [ 第二聯：自備物品 ] </b> 

                <hr className  = "border m_Bottom_30" />

                { /* 服務日期、Ｑ碼、類型、id */ }
                <Service_Tag_ServiceDate data = { data } />

                { /* 寵物資訊 */ }
                <Service_Tag_PetInfo pet = { pet } />

                { /* 自備物品 */ } 
                <Service_Tag_Section icon = "fas fa-sign" title = "自備物品" content = { customer_Object } />
					
				</div>
				
				<div style={{ pageBreakAfter: 'always' }}>

                <b className   = "f_15" >  [ 第三聯：服務記錄 ] </b> 

                <hr className  = "border m_Bottom_30" />

                { /* 服務日期、Ｑ碼、類型、id */ }
                <Service_Tag_ServiceDate data = { data } />

                { /* 寵物資訊 */ }
                <Service_Tag_PetInfo pet = { pet } />

                { /* 到店、離店 */ }
                <Service_Tag_ArriveLeave arrive = { data?.way_arrive } leave = { data?.way_leave } />
               
                { /* 主人資訊 */ } 
                <div className = "t_Left m_Bottom_30" > 
                   手機 : { customer?.mobile_phone } ( { string_Replace_WithAsterisks( customer?.name ) } )     
                </div>

                { /* 服務單( 基礎、洗澡、美容 )內容 */ }
                <Service_Tag_ServiceContent data = { data } />
                
                { /* 健康相關 */ } 
                <div style = {{ pageBreakInside : "avoid" }} >

                    { /* <Service_Tag_Section icon = "fas fa-medkit" title = "健康相關" content = "老犬、心臟病" /> */ }

                    { /* 洗澡美容備註 */ }
                    <Service_Tag_Section icon = "fas fa-dog" title = "洗澡美容 : 常駐備註" content = { pet_Note } options = { pet?.check_note }  />

                    { /* 自備物品 */ } 
                    <Service_Tag_Section icon = "fas fa-sign" title = "自備物品" content = { customer_Object } />

                </div>
               
			    </div>


                {/* <div className = "t_Left m_Top_20 m_Bottom_20 relative"  >  

                   <div className = "relative w-50"  >

                     <span className="tag is-large m_Right_10 is-white f_18 relative" style={{left:"-40px"}} > 
                        <i className = "fas fa-user-edit" ></i> 
                     </span>   
                     <span className = "f_14 relative" style = {{ left:"-68px" }} > 客戶簽收 :  </span>  

                   </div>

                   <div className = "w-50 p_10 absolute" style = {{ left : "140px" , top : "30px" , borderBottom : "1px solid black" }} >  </div>
                   
                </div> */}
                    
           </div>

} ;


export default Service_Tag_6
       